import { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("working"); // working | done | error
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) {
      setStatus("error");
      return;
    }
    api.post("/digest/unsubscribe", { token })
      .then(() => setStatus("done"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <main className="max-w-md mx-auto px-6 py-24 text-center">
      <div className="fleuron mb-6">❦</div>
      {status === "working" && (
        <>
          <h1 className="font-display text-4xl">Quieting the post…</h1>
          <p className="font-body text-ink-iron mt-4">Removing your name from the estate's weekly letter.</p>
        </>
      )}
      {status === "done" && (
        <>
          <h1 className="font-display text-4xl text-wax-red">It is done.</h1>
          <p className="font-body text-ink-iron mt-4 text-lg">
            We shall no longer write you weekly letters. Account notices (sign-up, password, applications) will still arrive when needed.
          </p>
          <p className="font-body text-ink-marginalia mt-2 italic">Change your mind any time from email preferences.</p>
          <div className="mt-8 flex justify-center gap-4">
            <Link to="/email-preferences" className="ghost-button">Email preferences</Link>
            <Link to="/" className="wax-button">Return home</Link>
          </div>
        </>
      )}
      {status === "error" && (
        <>
          <h1 className="font-display text-4xl">The seal would not break.</h1>
          <p className="font-body text-ink-iron mt-4">The unsubscribe link is invalid or expired. Try managing preferences from your account instead.</p>
          <Link to="/email-preferences" className="wax-button mt-6 inline-block">Email preferences</Link>
        </>
      )}
    </main>
  );
}
